import { Typography, Accordion, AccordionSummary, AccordionDetails, Card, CardContent } from '@mui/material';
import { CottageOutlined } from '@mui/icons-material';

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import TitleBar from '../../titleBar/TitleBar';

export default function BoilerApartMenu({ boilerAparts, userName }) {
    return (
        <Accordion>
            <AccordionSummary
                expandIcon={<KeyboardArrowUpIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
            >
                <TitleBar title="Список объектов" noBorder compact />
            </AccordionSummary>

            <AccordionDetails>
                {boilerAparts?.map((item) => (
                    <Card
                        key={item.id}
                        sx={{
                            mb: 2,
                            display: 'flex',
                            alignItems: 'center',
                            p: 1,
                            borderRadius: 2,
                            boxShadow: 2,
                        }}
                    >
                        <CottageOutlined color="primary" fontSize="large" sx={{ mr: 2 }} />

                        <CardContent sx={{ flex: 1, p: 0 }}>
                            <Typography variant="h6">
                                {item.name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Адрес: {item.address}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Договор: № {item.contract_num}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Владелец: {userName}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Площадь: {item.totalArea != null ? item.totalArea + " м²" : "-"}
                            </Typography>
                        </CardContent>
                    </Card>
                ))}
            </AccordionDetails>

        </Accordion>
    );
}
